<template>
	<li class="node-tree" v-if="typeof node != 'undefined'" :class="[{'root':node.ness_level==1}]">
		<span class="label">{{ node.name }}</span>
		<ul v-if="node.children && node.children.length">
			<ReBranchTreeNode v-for="child in node.children" :node="child" />
		</ul>
	</li>
</template>

<script>
export default {
	name: "ReBranchTreeNode",
	props: {
		node: Object
	}
};
</script>